<template>
  <div>
    <Head title="Dashboard" />
    <!-- <h1 class="mb-8 text-3xl font-bold">Dashboard</h1> -->
    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      <div class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Calls</span>
          <h1 class="text-5xl font-bold">{{ callsToday }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-headset text-indigo-600 text-4xl" />
          </div>
        </div>
      </div>
      <div class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Texts</span>
          <h1 class="text-5xl font-bold">{{ textsToday }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-sms text-indigo-600 text-4xl" />
          </div>
        </div>
      </div>
      <div class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Emails</span>
          <h1 class="text-5xl font-bold">{{ emailsToday }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-envelope text-indigo-600 text-4xl" />
          </div>
        </div>
      </div>
      <div class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Contacts Per Lead</span>
          <h1 class="text-5xl font-bold">{{ contactsPerLead }}</h1>
        </div>
        <div>
          <i class="fas fa-chart-bar text-indigo-600 text-4xl" />
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-5 mt-6 sm:grid-cols-2 lg:grid-cols-3">
      <div class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Todays Leads</span>
          <h1 class="text-5xl font-bold">{{ leadsToday }}</h1>
        </div>
        <div>
          <i class="fas fa-user text-indigo-600 text-4xl" />
        </div>
      </div>
      <div class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Leads 7 Days</span>
          <h1 class="text-5xl font-bold">{{ leadsLastWeek }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-users text-indigo-600 text-4xl" />
          </div>
        </div>
      </div>
      <div class="flex items-center justify-around p-6 bg-white w-full rounded-xl space-x-2 mt-2 transition-shadow border rounded-lg shadow-sm hover:shadow-lg">
        <div>
          <span class="text-sm font-semibold text-gray-400">Leads 30 Days</span>
          <h1 class="text-5xl font-bold">{{ leadsLastMonth }}</h1>
        </div>
        <div>
          <div>
            <i class="fas fa-headset text-indigo-600 text-4xl" />
          </div>
        </div>
      </div>
    </div>


    <!-- <h1 class="mb-8 mt-8 text-3xl font-bold">Lead Percentage Contacted</h1> -->
    <div class="pb-4 pt-8 w-full">
      <div class="w-full h-10 bg-gray-200 rounded-full">
        <div id="bar" class="h-full text-xs font-medium text-white text-center p-0.5 leading-none rounded-full pt-4">{{ totalProgress }}%</div>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-5 mt-6">
      <div class="bg-white rounded-md shadow w-full mb-10 transition-shadow border rounded-lg shadow-md hover:shadow-xl">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            Leaderboard
          </h2>
        </div>
        <div>
          <div class="bg-white rounded shadow mb-5 w-full">
            <table class="text-left p-5 w-full" style="height: 30vh;">
              <thead class="w-full flex bg-gray-100">
                <tr class="w-full flex font-bold p-5">
                  <th class="w-2/6">Loan Officer</th>
                  <th class="w-1/6 text-center">Calls</th>
                  <th class="w-1/6 text-center">Emails</th>
                  <th class="w-1/6 text-center">Texts</th>
                  <th class="w-1/6 text-center">Total</th>
                </tr>
              </thead>
              <tbody class="bg-grey-light flex flex-col items-center overflow-y-scroll w-full" style="height: 30vh;">
                <tr v-for="loanOfficer in leaderboard" :key="loanOfficer.loanOfficer" class="hover:bg-gray-100 flex w-full focus-within:bg-gray-100">
                  <td class="border-t w-2/4 pl-5">
                    <div class="w-full text-m my-2">
                      <div class="font-semibold">
                        {{ loanOfficer.loanOfficer }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t py-2 text-center w-1/4">
                    <div>
                      <div class="w-full">
                        {{ loanOfficer.calls }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t py-2 text-center w-1/4">
                    <div>
                      <div class="w-full">
                        {{ loanOfficer.emails }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t py-2 text-center w-1/4">
                    <div>
                      <div class="w-full">
                        {{ loanOfficer.texts }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t py-2 text-center w-1/4 pr-8">
                    <div>
                      <div class="w-full">
                        {{ loanOfficer.total }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="leaderboard.length === 0">
                  <td class="border-t p-2 text-center pt-4" colspan="4">No Leaders.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>



    <div class="grid grid-cols-1 gap-5 mt-6 lg:grid-cols-3">
      <div class="bg-white rounded-md shadow w-full mb-10 transition-shadow border rounded-lg shadow-md hover:shadow-xl">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            Today's Reminders
          </h2>
        </div>
        <div>
          <div class="bg-white rounded shadow mb-5 w-full">
            <table class="text-left p-5 w-full" style="height: 40vh;">
              <thead class="w-full flex bg-gray-100">
                <tr class="w-full flex p-5">
                  <th class="w-2/4 text-left">Reminder</th>
                  <th class="w-1/4 text-left">Date/Time</th>
                  <th class="w-1/4 text-right justify-end">Actions</th>
                </tr>
              </thead>
              <tbody class="bg-grey-light flex flex-col items-center overflow-y-scroll w-full" style="height: 40vh;">
                <tr v-for="reminder in tasks" :key="reminder.id" :value="reminder.id" class="hover:bg-gray-100 flex w-full focus-within:bg-gray-100">
                  <td class="border-t w-2/4 pl-5">
                    <div class="w-full text-m my-2">
                      <div class="w-full text-sm py-1">
                        {{ reminder.readable }}
                      </div>
                      <div>
                        {{ truncate(reminder.message, 40, '...') }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t py-2 text-center w-1/4">
                    <div>
                      <div class="w-full text-sm py-1">
                        {{ reminder.date }}
                      </div>
                      <div class="w-full text-sm">
                        {{ reminder.time }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t text-right w-1/4">
                    <div class="flex justify-end md:text-right text-xl my-2 mr-4">
                      <Link v-if="reminder.contact_id"  class="cursor-pointer py-2" :href="`/contacts/${reminder.contact_id}/edit`">
                        <i class="far fa-user text-green-500 mr-3" />
                      </Link>
                      <Link v-if="reminder.lead_id" class="cursor-pointer py-2" :href="`/leads/${reminder.lead_id}/edit`">
                        <i class="far fa-user text-green-500 mr-3" />
                      </Link>
                      <TaskEdit :task="reminder">
                        <template #buttonTop>
                          <button class="cursor-pointer py-2"> <i class="far fa-edit text-indigo-500" /></button>
                        </template>
                      </TaskEdit>
                      <button class="cursor-pointer py-2" tabindex="-1" type="button" @click="destroyTask(reminder.id)"><i class="ml-2 far fa-trash-alt text-red-500" /></button>
                    </div>
                  </td>
                </tr>
                <tr v-if="tasks.length === 0">
                  <td class="p-2 text-center pt-4" colspan="3">No Upcoming Reminders.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>




      <div class="bg-white rounded-md shadow w-full mb-10 transition-shadow border rounded-lg shadow-md hover:shadow-xl">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            Loan Anniversary
          </h2>
        </div>
        <div>
          <div class="bg-white rounded shadow mb-5 w-full">
            <table class="text-left p-5 w-full" style="height: 40vh;">
              <thead class="w-full flex">
                <tr class="w-full flex text-left bg-gray-100">
                  <th class="p-5 w-3/6">Name</th>
                  <th class="p-5 w-2/6">Closed</th>
                  <th class="p-5 w-1/6" />
                </tr>
              </thead>
              <tbody class="bg-grey-light flex flex-col items-center overflow-y-scroll w-full" style="height: 40vh;">
                <tr v-for="closing in closed" :key="closing.id" :value="closing.id" class="hover:bg-gray-100 flex w-full focus-within:bg-gray-100">
                  <td class="border-t w-3/6 pl-5">
                    <div class="w-full text-m">
                      <Link class="flex py-4 focus:text-indigo-500" :href="`/leads/${closing.id}/edit`">{{ closing.fullName }}</Link>
                    </div>
                  </td>
                  <td class="border-t pt-4 text-center w-2/6">
                    <div>
                      <div class="w-full text-m">
                        {{ closing.closed }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t text-right w-1/6">
                    <div class="flex md:text-right text-xl text-center">
                      <Link class="flex py-4 focus:text-indigo-500" :href="`/leads/${closing.id}/edit`"><i class="far fa-user text-green-500 mr-3" /></Link>
                    </div>
                  </td>
                </tr>
                <tr v-if="closed.length === 0">
                  <td class="p-2 text-center" colspan="3">No Upcoming Anniversaries.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>




      <div class="bg-white rounded-md shadow w-full mb-10 transition-shadow border rounded-lg shadow-md hover:shadow-xl">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            Birthdays
          </h2>
        </div>
        <div>
          <div class="bg-white rounded shadow mb-5 w-full">
            <table class="text-left p-5 w-full" style="height: 40vh;">
              <thead class="w-full flex bg-gray-100">
                <tr class="w-full flex text-left font-bold">
                  <th class="p-5 w-3/6">Name</th>
                  <th class="p-5 w-2/6">Birthday</th>
                  <th class="p-5 w-1/6" />
                </tr>
              </thead>
              <tbody class="bg-grey-light flex flex-col items-center overflow-y-scroll w-full" style="height: 40vh;">
                <tr v-for="birthday in birthdays" :key="birthday.id" :value="birthday.id" class="hover:bg-gray-100 flex w-full focus-within:bg-gray-100">
                  <td class="border-t w-3/6 pl-5">
                    <div class="w-full text-m">
                      <Link v-if="birthday.type == 'lead'" class="flex py-4 focus:text-indigo-500" :href="`/leads/${birthday.id}/edit`">{{ birthday.fullName }}</Link>
                      <Link v-if="birthday.type == 'contact'" class="flex py-4 focus:text-indigo-500" :href="`/contacts/${birthday.id}/edit`">{{ birthday.fullName }}</Link>
                    </div>
                  </td>
                  <td class="border-t pt-4 text-center w-2/6">
                    <div>
                      <div class="w-full text-m">
                        {{ birthday.birthday }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t text-right w-1/6">
                    <div class="flex md:text-right text-xl text-center">
                      <Link v-if="birthday.type == 'lead'" class="flex py-4 focus:text-indigo-500" :href="`/leads/${birthday.id}/edit`"><i class="far fa-user text-green-500 mr-3" /></Link>
                      <Link v-if="birthday.type == 'contact'" class="flex py-4 focus:text-indigo-500" :href="`/contacts/${birthday.id}/edit`"><i class="far fa-user text-green-500 mr-3" /></Link>
                    </div>
                  </td>
                </tr>
                <tr v-if="birthdays.length === 0">
                  <td class="p-2 text-center" colspan="3">No Upcoming Birthdays.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>


    <div class="grid grid-cols-1 gap-5 mt-6">
      <div class="bg-white rounded-md shadow w-full mb-10 transition-shadow border rounded-lg shadow-md hover:shadow-xl">
        <div class="p-6 min-w-max">
          <h2 class="font-bold text-center text-2xl text-indigo-500">
            Recent Messages
          </h2>
        </div>
        <div>
          <div class="bg-white rounded shadow mb-5 w-full">
            <table class="text-left p-5 w-full" style="height: 30vh;">

              <tbody class="bg-grey-light flex flex-col items-center overflow-y-scroll w-full" style="height: 30vh;">
                <tr v-for="note in notesRecent" :key="note.id" class="hover:bg-gray-100 flex w-full focus-within:bg-gray-100">
                  <td class="border-t w-1/4 md:w-1/6 mr-4 p-5 text-center md:text-left">
                    <div class="w-full text-m">
                      <Link v-if="note.contact_id" class="w-full" :href="`/contacts/${note.contact_id}/edit`"><div>
                        {{ note.first_name }} {{ note.last_name }}
                        </div>
                      </Link>
                      <Link class="w-full" :href="`/leads/${note.lead_id}/edit`"><div>
                        {{ note.fullName }}
                        </div>
                      </Link>
                    </div>
                  </td>
                  <td class="hidden md:block border-t p-5 text-center w-1/6">
                    <div>
                      <div class="w-full text-sm">
                        {{ datestamp(note.created_at) }}  {{ timestamp(note.created_at) }}
                      </div>
                    </div>
                  </td>
                  <td class="border-t py-2 text-center w-1/6 hidden md:block">
                    <div>
                      <div class="w-full">
                      <div class="w-full">
                        <IconNotes :name="note.type" class="w-full" />
                      </div>
                      </div>
                    </div>
                  </td>
                  <td class="w-3/4 md:w-5/6 border-t p-2 text-center">
                    <div>
                      <div class="w-full text-sm">
                        {{ truncatedMessage(note.message) }}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="notesRecent.length === 0">
                  <td class="border-t p-2 text-center pt-4" colspan="4">No Recent Incoming Messages.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>





  </div>
</template>
<script>
import { Head, Link, router } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import moment from 'moment'
import TaskEdit from '@/Shared/TaskEdit'
import IconNotes from '@/Shared/IconNotes'
import { ref, onMounted, onUnmounted, watch } from 'vue'

export default {
  components: {
    Head,
    Link,
    TaskEdit,
    IconNotes,
  },
  layout: Layout,
  props: {
    leadsActive: Number,
    leadsToday: Number,
    leadsLastWeek: Number,
    leadsLastMonth: Number,
    leadsTotal: Number,
    emailsToday: Number,
    callsToday: Number,
    textsToday: Number,
    totalProgress: Number,
    birthdays: Array,
    closed: Array,
    tasks: Array,
    notesRecent: Array,
    leaderboard: Array,
  },
  setup(props) {
    const isPolling = ref(false)
    let pollInterval = null

    const updateChart = (totalProgress) => {
      let progress = 0
      let invervalSpeed = 10
      let incrementSpeed = 1
      let bar = document.getElementById('bar')
      
      if (!bar) return // Guard clause in case element doesn't exist
      
      // Reset bar width and remove all color classes
      bar.style.width = '0%'
      bar.classList.remove(
        'bg-red-800', 
        'bg-red-500', 
        'bg-orange-500', 
        'bg-orange-400', 
        'bg-yellow-400', 
        'bg-green-500', 
        'bg-green-800'
      )

      // Determine color class based on new total progress
      let colorClass
      if (totalProgress > 0 && totalProgress < 10) {
        colorClass = 'bg-red-800'
      } else if (totalProgress >= 10 && totalProgress < 25) {
        colorClass = 'bg-red-500'
      } else if (totalProgress >= 25 && totalProgress < 40) {
        colorClass = 'bg-orange-500'
      } else if (totalProgress >= 40 && totalProgress < 60) {
        colorClass = 'bg-orange-400'
      } else if (totalProgress >= 60 && totalProgress < 75) {
        colorClass = 'bg-yellow-400'
      } else if (totalProgress >= 75 && totalProgress < 95) {
        colorClass = 'bg-green-500'
      } else if (totalProgress >= 95) {
        colorClass = 'bg-green-800'
      }
      
      // Add new color class
      if (colorClass) {
        bar.classList.add(colorClass)
      }

      // Animate progress bar
      let progressInterval = setInterval(function() {
        progress += incrementSpeed
        bar.style.width = progress + '%'
        if (progress >= totalProgress) {
          clearInterval(progressInterval)
        }
      }, invervalSpeed)
    }

    const startPolling = () => {
      if (!isPolling.value) {
        isPolling.value = true
        pollInterval = setInterval(() => {
          router.reload({ 
            only: ['leadsActive', 'leadsToday', 'leadsTotal', 'emailsToday', 'callsToday', 'textsToday', 'totalProgress', 'tasks', 'notesRecent', 'leaderboard'],
            preserveState: true,
            preserveScroll: true,
            replace: true,
          })
        }, 30000)
      }
    }

    const stopPolling = () => {
      if (isPolling.value) {
        isPolling.value = false
        clearInterval(pollInterval)
      }
    }

    // Watch for changes in totalProgress
    watch(() => props.totalProgress, (newValue) => {
      updateChart(newValue)
    })

    onMounted(() => {
      startPolling()
      updateChart(props.totalProgress) // Initial chart update
    })

    onUnmounted(() => {
      stopPolling()
    })

    return {
      isPolling,
      startPolling,
      stopPolling,
      updateChart // Expose updateChart function
    }
  },
  computed: {
    contactsPerLead() {
      var contactsTotal = this.emailsToday + this.callsToday + this.textsToday
      var contactsPerLead = contactsTotal / this.leadsActive
      return contactsPerLead.toFixed(2)
    },
  },
  methods: {
    truncatedMessage(message) {
      return message.length > 160 ? message.substring(0, 160) + '...' : message
    },
    truncate(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      }
      return text
    },
    destroyTask(id) {
      if (confirm('Are you sure you want to delete this task?')) {
        router.delete(`/tasks/${id}`, { 
          only: ['tasks'], 
          preserveScroll: true 
        })
      }
    },
    datestamp(date) {
      return moment(date).format('MM/DD/YY')
    },
    timestamp(date) {
      return moment(date).format('h:mm A')
    }
  },
}
</script>
